import axios from "axios";
import { ENDPOINT_SETTINGS, ENDPOINT_UPDATE_SETTINGS, ENDPOINT_TEST_CONNECTION } from "../../constants";

export async function updateSettings(key?: Blob, hosts: string[] = []): Promise<string> {
    const fdata = new FormData();
    if (key) {
        fdata.append("key", key);
    }
    if (hosts.length > 0) {
        fdata.append("hosts", JSON.stringify(hosts));
        fdata.append("host", hosts[0]);
    }

    try {
        const res = await axios.post(
            ENDPOINT_UPDATE_SETTINGS,
            fdata,
            {
                headers: { "Content-Type": "multipart/form-data" },
                withCredentials: true,
            },
        );
        return res.data.Code;
    } catch (error: any) {
        if (error.response?.status === 403) {
            console.error("Admin role required to update settings");
            return "admin_role_required";
        }
        console.error("Settings update error:", error);
        throw error;
    }
}

export async function retrieveSettings(): Promise<any> {
    const res = await axios.get(ENDPOINT_SETTINGS, {
        withCredentials: true,
    });
    return res.data;
}

export interface TestConnectionResponse {
    success: boolean;
    statusCode: number;
    statusText: string;
    responseTime: number; // milliseconds
    responseData?: {
        status?: string;
        casaStatus?: string;
        casaTimestamp?: string;
        [key: string]: any; // Allow other fields
    };
    error?: string;
}

export async function testConnection(host: string): Promise<TestConnectionResponse> {
    const res = await axios.post(ENDPOINT_TEST_CONNECTION, 
        { host },
        { withCredentials: true }
    );
    return res.data.Msg;
}
